/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B040030 発注明細照会
 */

import { Column, Query } from "@material-table/core";
import {
  B000170ShireNmr,
  B000190SokoNmr,
  B000200JanshohinNm1,
  B000200ShohinNmr,
  B040020Get,
  B040030Find,
  B040030FindRequest,
  B040030GetExcel,
  catchFileError,
  catchRestError,
} from "clients/rest";
import {
  msgState,
  SCodeSelect,
  SDateField,
  SFileButton,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  STable,
  SText,
  STextField,
} from "components";
import { getClientMessage } from "messages";
import {
  B040030SyuturyokuKbn,
  getSCode,
  HachuKanryoKbn,
  SCode,
  ZenkenShohinshubetsuKbn,
} from "messages/codes";
import { labels } from "messages/labels";
import {
  B000130,
  B000140,
  B000170,
  B000190,
  B000200,
  B000202,
  B040010InputData,
} from "pages";
import { B000120 } from "pages/b000/B000120";
import { createRef, useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import {
  atom,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from "recoil";
import { download, mapIds } from "services";
import { editKbn, eigyoKengen } from "services/codes";
import { date, dateWithSlashAt } from "services/DateService";
import {
  authState,
  focusState,
  menusState,
  navigateTypeState,
  useFocus,
} from "states";

// TODO: 入力部shohinNmrが二つある→JAN 商品名をjanshohinNmにしていただく
// TODO: テーブル部仕入担当部門bomonNmrとなっている

// 呼び出し時のプロパティ
type Props = Partial<{
  // 呼び出し元へデータを送る場合に設定する。
  handleSubmit: (data: any) => void;
}>;

// 検索条件を格納するデータタイプ
type SearchedFields = {
  searched: boolean;
} & Partial<{
  fields: Fields;
  page: number;
  pageSize: number;
  sort: string[];
}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  hachuYmdFrom: string;
  hachuYmdTo: string;
  nyukayoteiYmdFrom: string;
  nyukayoteiYmdTo: string;
  eigyoCdFrom: string;
  eigyoCdTo: string;
  bumonCdFrom: string;
  bumonCdTo: string;
  shainCdFrom: string;
  shainCdTo: string;
  hachudenpyoNoFrom: string;
  hachudenpyoNoTo: string;
  shireCd: string;
  shireNmr: string;
  sokoCd: string;
  sokoNmr: string;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  shohinCd: string;
  shohinNmr: string;
  kanryoKbn: SCode;
  janCd: string;
  janshohinNm: string;
  shuturyokuKbn: SCode;
  shohinsyubetsuKbn: SCode;
}>;

// テーブル定義
type Data = Partial<{
  gyoNo: string;
  uchiwakeNmr: string;
  hachuYmd: string;
  nyukayoteiYmd: string;
  hachudenpyoNo: string;
  hachudenpyoNoF: string;
  hachugyoNo: string;
  shohinCd: string;
  shohinNm: string;
  hachusu: string;
  shiresu: string;
  hachuzansu: string;
  hachuKin: string;
  hachuzanKin: string;
  sokoCd: string;
  sokoNm: string;
  shireNm: string;
  shainNm: string;
  bumonNmr: string;
  kanryoKbnView: string;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  hachuYmdFrom: "",
  hachuYmdTo: "",
  nyukayoteiYmdFrom: "",
  nyukayoteiYmdTo: "",
  eigyoCdFrom: "",
  eigyoCdTo: "",
  bumonCdFrom: "",
  bumonCdTo: "",
  shainCdFrom: "",
  shainCdTo: "",
  hachudenpyoNoFrom: "",
  hachudenpyoNoTo: "",
  shireCd: "",
  shireNmr: "",
  sokoCd: "",
  sokoNmr: "",
  shodaibun: "",
  shochubun: "",
  shoshobun: "",
  shohinCd: "",
  shohinNmr: "",
  kanryoKbn: getSCode(HachuKanryoKbn, "0"),
  janCd: "",
  janshohinNm: "",
  shuturyokuKbn: getSCode(B040030SyuturyokuKbn, "0"),
  shohinsyubetsuKbn: getSCode(ZenkenShohinshubetsuKbn, "0"),
};

// テーブルを定義する。
const columns: Column<Data>[] = [
  { field: "gyoNo", title: "行　", width: "4rem", align: "right" },
  {
    field: "uchiwakeNmr",
    title: "区分",
    width: "5rem",
  },
  {
    field: "hachuYmd",
    title: "発注日",
    width: "6rem",
    render: (data) => {
      if (data.hachuYmd! !== null && data.hachuYmd! !== "") {
        return dateWithSlashAt(data.hachuYmd!);
      }
    },
  },
  {
    field: "nyukayoteiYmd",
    title: "入荷予定日",
    width: "6rem",
    render: (data) => {
      if (data.nyukayoteiYmd! !== null && data.nyukayoteiYmd! !== "") {
        return dateWithSlashAt(data.nyukayoteiYmd!);
      }
    },
  },
  { field: "hachudenpyoNoF", title: "発注No.", width: "8rem" },
  { field: "shohinCd", title: "商品コード", width: "8rem" },
  { field: "shohinNm", title: "商品名", width: "20rem" },
  {
    field: "hachusu",
    title: "発注数　",
    width: "6rem",
    align: "right",
    render: (data) => data.hachusu?.toLocaleString(),
  },
  {
    field: "shiresu",
    title: "入荷数　",
    width: "6rem",
    align: "right",
    render: (data) => data.shiresu?.toLocaleString(),
  },
  {
    field: "hachuzansu",
    title: "発注残数　",
    width: "9rem",
    align: "right",
    render: (data) => data.hachuzansu?.toLocaleString(),
  },
  {
    field: "hachuKin",
    title: "発注金額　",
    width: "9rem",
    align: "right",
    render: (data) => data.hachuKin?.toLocaleString(),
  },
  {
    field: "hachuzanKin",
    title: "発注残金額　",
    width: "9rem",
    align: "right",
    render: (data) => data.hachuzanKin?.toLocaleString(),
  },
  { field: "sokoCd", title: "倉庫コード", width: "6rem" },
  { field: "sokoNm", title: "倉庫名", width: "10rem" },
  { field: "shireNm", title: "仕入先", width: "15rem" },
  { field: "shainNm", title: "発注担当者", width: "8rem" },
  { field: "bumonNmr", title: "発注担当部門", width: "6rem" },
  { field: "kanryoKbnView", title: "完了区分", width: "4rem" },
  { field: "hachudenpyoNo", title: "発注No.", hidden: true },
  { field: "hachugyoNo", title: "発注行番号", hidden: true },
];

const focusId = "B040030";

// B040030 発注明細照会
export const B040030 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

// 検索条件を格納するステート
const B040030State = atom<SearchedFields>({
  key: "B040030State",
  default: {
    searched: false,
    fields: defaultFields,
  },
});

const Page = (props: Props) => {
  // 状態管理の初期設定
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  // テーブルの値取得用Ref
  const tableRef = createRef();
  // 1ページの行数
  const pageSize = 15;
  // 初回検索用のフラグ
  const [searched, setSearched] = useState(false);
  // 検索ボタン押下時に初期ページにするステート
  const isDefaultPage = useRef(false);
  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // テーブル行で選択されたデータ
  const [rowData, setRowData] = useState<Partial<Data>>();
  // 検索条件保存
  const [searchedFeields, setSearchedFields] = useRecoilState(B040030State);

  // メッセージ表示
  const setMsg = useSetRecoilState(msgState);

  // 画面遷移の処理
  const navigate = useNavigate();
  const [menuNavigate, setMenuNavigate] = useRecoilState(navigateTypeState);

  // ボタンの活性・非活性
  const [disabledHachuDetail, setDisabledHachuDetail] = useState(true);
  const [disabledHachuExcel, setDisabledHachuExcel] = useState(true);

  // ログインユーザー情報
  const auth = useRecoilValue(authState);
  // 所属営業所コードでの営業所コード入力制御
  const [isEigyoCdHonsha, setIsEigyoCdHonsha] = useState(true);
  // menusステート取得
  const menus = useRecoilValue(menusState);
  // 営業所権限取得
  const eigyosyoKengen = menus["040"].pages["040030"].eigyosyoKengen;

  // 初期表示イベント
  useEffect(() => {
    if (menuNavigate === "menu") {
      // 自営業所の設定
      // イベント利用権限定義マスタ.営業所権限が"0"(所属営業所のみ指定可)の場合、
      if (eigyosyoKengen === eigyoKengen.only) {
        // 自営業所コード(変更不可)の設定
        methods.setValue("eigyoCdFrom", auth?.eigyoCd!);
        methods.setValue("eigyoCdTo", auth?.eigyoCd!);
        // 入力部非活性化
        setIsEigyoCdHonsha(false);
      }
      // 利用権限定義マスタ.営業所権限が"1"(全営業所指定可権限)の場合、
      else if (eigyosyoKengen === eigyoKengen.all) {
        // 空白(入力可能)
        setIsEigyoCdHonsha(true);
      }
      // 初期表示
      (async () => {
        await methods.setValue("hachuYmdFrom", date());
        methods.setValue("hachuYmdTo", date());
        focus(1);
      })();
      return;
    }

    if (searchedFeields.searched) {
      // 検索条件が保存されている
      const fields = searchedFeields.fields;
      if (typeof fields !== "undefined") {
        methods.setValue("hachuYmdFrom", fields.hachuYmdFrom);
        methods.setValue("hachuYmdTo", fields.hachuYmdTo);
        methods.setValue("nyukayoteiYmdFrom", fields.nyukayoteiYmdFrom);
        methods.setValue("nyukayoteiYmdTo", fields.nyukayoteiYmdTo);
        methods.setValue("eigyoCdFrom", fields.eigyoCdFrom);
        methods.setValue("eigyoCdTo", fields.eigyoCdTo);
        methods.setValue("bumonCdFrom", fields.bumonCdFrom);
        methods.setValue("bumonCdTo", fields.bumonCdTo);
        methods.setValue("shainCdFrom", fields.shainCdFrom);
        methods.setValue("shainCdTo", fields.shainCdTo);
        methods.setValue("hachudenpyoNoFrom", fields.hachudenpyoNoFrom);
        methods.setValue("hachudenpyoNoTo", fields.hachudenpyoNoTo);
        methods.setValue("shireCd", fields.shireCd);
        methods.setValue("shireNmr", fields.shireNmr);
        methods.setValue("sokoCd", fields.sokoCd);
        methods.setValue("shodaibun", fields.shodaibun);
        methods.setValue("shochubun", fields.shochubun);
        methods.setValue("shoshobun", fields.shoshobun);
        methods.setValue("shohinCd", fields.shohinCd);
        methods.setValue("shohinNmr", fields.shohinNmr);
        methods.setValue("kanryoKbn", fields.kanryoKbn);
        methods.setValue("janCd", fields.janCd);
        methods.setValue("janshohinNm", fields.janshohinNm);
        methods.setValue("shuturyokuKbn", fields.shuturyokuKbn);
        methods.setValue("shohinsyubetsuKbn", fields.shohinsyubetsuKbn);
        setSearched(true);
        return;
      }
    }
  }, []);

  // テーブル行選択時
  const handleSelectTableRow = (_: any, rowData: Data | undefined) => {
    // 行が選択されていないときはボタン非活性
    const disabled = typeof rowData === "undefined";
    setDisabledHachuDetail(disabled);

    // データを保存
    setRowData(rowData);
  };

  // テーブル行ダブルクリック時・詳細ボタンクリック時
  const handleDoubleClickTableRow = (data: Data) => {
    // 受注データの検索を行う
    B040020Get({ hachudenpyoNo: data.hachudenpyoNo })
      .then((value) => {
        // 確定済・キャンセル済のデータ→参照モード それ以外→編集モード
        const inputData: B040010InputData = {
          editKbn: editKbn.update,
          hachu: value.data,
        };
        setSearchedFields({ searched: true, fields: methods.getValues() });
        // 発注入力画面へ遷移する。
        setMenuNavigate("next");
        navigate("/b040010", { state: inputData });
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 詳細ボタンクリック時
  const handleClickShowDetailButton = () => {
    // 行が選択されている場合のみ実行する。
    if (typeof rowData === "undefined") {
      return;
    }

    // 発注データの検索を行う
    B040020Get({ hachudenpyoNo: rowData.hachudenpyoNo })
      .then((value) => {
        const inputData: B040010InputData = {
          editKbn: editKbn.update,
          hachu: value.data,
        };
        setSearchedFields({ searched: true, fields: methods.getValues() });
        // 発注入力画面へ遷移する。
        setMenuNavigate("next");
        navigate("/b040010", { state: inputData });
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // Excel出力ボタンクリックイベント
  const handleClickExcelButton = (data: Data) => {
    // 検索フォームのデータを取得する。
    const fields = methods.getValues();

    // 完了区分
    let paramKanryoKbn;
    // 未完了
    if (fields.kanryoKbn?.value! === "0") {
      paramKanryoKbn = fields.kanryoKbn?.value!;
      // 全件
    } else if (fields.kanryoKbn?.value! === "1") {
      paramKanryoKbn = "2";
    }

    // 出力順に応じたソート処理
    let order;
    if (fields.shuturyokuKbn?.value === "0") {
      order = ["hachuYmd,asc", "hachudenpyoNo,asc", "hachugyoNo,asc"];
    } else if (fields.shuturyokuKbn?.value === "1") {
      order = ["nyukayoteiYmd,asc", "hachudenpyoNo,asc", "hachugyoNo,asc"];
    } else if (fields.shuturyokuKbn?.value === "2") {
      order = ["shohinCd,asc", "hachudenpyoNo,asc", "hachugyoNo,asc"];
    } else if (fields.shuturyokuKbn?.value === "3") {
      order = ["shireCd,asc", "hachudenpyoNo,asc", "hachugyoNo,asc"];
    } else if (fields.shuturyokuKbn?.value === "4") {
      order = ["sokoCd,asc", "hachudenpyoNo,asc", "hachugyoNo,asc"];
    } else if (fields.shuturyokuKbn?.value === "5") {
      order = ["hachudenpyoNo,asc", "hachugyoNo,asc"];
    }

    // Excel出力パラメータを作成する。
    // 検索パラメータを作成する。
    const param: B040030FindRequest = {
      hachuYmdFrom: fields.hachuYmdFrom,
      hachuYmdTo: fields.hachuYmdTo,
      nyukayoteiYmdFrom: fields.nyukayoteiYmdFrom,
      nyukayoteiYmdTo: fields.nyukayoteiYmdTo,
      eigyoCdFrom: fields.eigyoCdFrom,
      eigyoCdTo: fields.eigyoCdTo,
      bumonCdFrom: fields.bumonCdFrom,
      bumonCdTo: fields.bumonCdTo,
      shainCdFrom: fields.shainCdFrom,
      shainCdTo: fields.shainCdTo,
      hachudenpyoNoFrom: fields.hachudenpyoNoFrom,
      hachudenpyoNoTo: fields.hachudenpyoNoTo,
      shireCd: fields.shireCd,
      sokoCd: fields.sokoCd,
      shodaibun: fields.shodaibun,
      shochubun: fields.shochubun,
      shoshobun: fields.shoshobun,
      shohinCd: fields.shohinCd,
      kanryoKbn: paramKanryoKbn,
      janCd: fields.janCd,
      shohinshubetsuKbn: fields.shohinsyubetsuKbn?.value,
      // ソートの設定
      sort: order,
    };
    // API呼び出し
    B040030GetExcel(param)
      .then((response) => {
        download(response);
        setMsg(getClientMessage("B040030_001"));
      })
      .catch((reason) => {
        catchFileError(reason, navigate, setMsg);
      });
  };

  // 検索時の初期化処理
  const handleResetSearch = () => {
    // 各ボタン非活性化
    setDisabledHachuDetail(true);
    // 選択されているデータを空にする
    setRowData({});
    (tableRef.current as any).handleClearSelect();
  };

  // 検索ボタンクリックイベント
  const handleClickSearchButton = () => {
    // 初期化
    handleResetSearch();
    // excelボタン非活性化
    setDisabledHachuExcel(true);
    // 検索可能に変更
    setSearched(true);
    // 初期ページ設定
    isDefaultPage.current = true;
    // テーブル再検索
    (tableRef.current as any).onQueryChange();
  };

  // // 検索イベント
  const handleSearch = (query: Query<Data>) => {
    return new Promise<any>((resolve) => {
      // 初回検索をしない
      if (!searched) {
        resolve({
          data: [],
          page: 0,
          totalCount: 0,
        });
        return;
      }

      // 検索フォームのデータを取得する。
      const fields = methods.getValues();

      // 完了区分
      let paramKanryoKbn;
      // 未完了
      if (fields.kanryoKbn?.value! === "0") {
        paramKanryoKbn = fields.kanryoKbn?.value!;
        // 全件
      } else if (fields.kanryoKbn?.value! === "1") {
        paramKanryoKbn = "2";
      }

      // 出力順に応じたソート処理
      let order;
      if (fields.shuturyokuKbn?.value === "0") {
        order = ["hachuYmd,asc", "hachudenpyoNo,asc", "hachugyoNo,asc"];
      } else if (fields.shuturyokuKbn?.value === "1") {
        order = ["nyukayoteiYmd,asc", "hachudenpyoNo,asc", "hachugyoNo,asc"];
      } else if (fields.shuturyokuKbn?.value === "2") {
        order = ["shohinCd,asc", "hachudenpyoNo,asc", "hachugyoNo,asc"];
      } else if (fields.shuturyokuKbn?.value === "3") {
        order = ["shireCd,asc", "hachudenpyoNo,asc", "hachugyoNo,asc"];
      } else if (fields.shuturyokuKbn?.value === "4") {
        order = ["sokoCd,asc", "hachudenpyoNo,asc", "hachugyoNo,asc"];
      } else if (fields.shuturyokuKbn?.value === "5") {
        order = ["hachudenpyoNo,asc", "hachugyoNo,asc"];
      }

      // 初期ページ表示の場合、0を設定する。
      query.page = isDefaultPage.current ? 0 : query.page;

      // 検索パラメータを作成する。
      const param: B040030FindRequest = {
        hachuYmdFrom: fields.hachuYmdFrom,
        hachuYmdTo: fields.hachuYmdTo,
        nyukayoteiYmdFrom: fields.nyukayoteiYmdFrom,
        nyukayoteiYmdTo: fields.nyukayoteiYmdTo,
        eigyoCdFrom: fields.eigyoCdFrom,
        eigyoCdTo: fields.eigyoCdTo,
        bumonCdFrom: fields.bumonCdFrom,
        bumonCdTo: fields.bumonCdTo,
        shainCdFrom: fields.shainCdFrom,
        shainCdTo: fields.shainCdTo,
        hachudenpyoNoFrom: fields.hachudenpyoNoFrom,
        hachudenpyoNoTo: fields.hachudenpyoNoTo,
        shireCd: fields.shireCd,
        sokoCd: fields.sokoCd,
        shodaibun: fields.shodaibun,
        shochubun: fields.shochubun,
        shoshobun: fields.shoshobun,
        shohinCd: fields.shohinCd,
        kanryoKbn: paramKanryoKbn,
        janCd: fields.janCd,
        shohinshubetsuKbn: fields.shohinsyubetsuKbn?.value,
        // ページネーションの設定
        page: query.page,
        size: query.pageSize,
        // ソートの設定
        sort: order,
      };
      // API呼出し
      B040030Find(param)
        // 正常値取得
        .then((value) => {
          const offset = query.pageSize * query.page;
          resolve({
            data: mapIds(value.data.content, "gyoNo", offset),
            page: value.data.number,
            totalCount: value.data.totalElements,
          });
          // Excel出力ボタン活性化
          setDisabledHachuExcel(value.data.content.length <= 0);
        })
        // エラー時
        .catch((reason) => {
          catchRestError(reason, navigate, setMsg);
          resolve({
            data: [],
            page: 0,
            totalCount: 0,
          });
        })
        .finally(() => {
          // 初期ページ表示をオフにする。
          isDefaultPage.current = false;
        });
    });
  };

  //   レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="発注明細照会"
        gridTemplateColumns="6rem 4rem 4rem 1rem 4rem 4rem 3rem 3rem 6rem 9rem 1rem 9rem 3rem"
      >
        <SLabel>発注日</SLabel>
        <SDateField name="hachuYmdFrom" gridColumn="span 2" {...register(1)} />
        <SText>～</SText>
        <SDateField name="hachuYmdTo" gridColumn="span 2" {...register(2)} />
        <SLabel gridColumn="9">入荷予定日</SLabel>
        <SDateField name="nyukayoteiYmdFrom" {...register(3)} />
        <SText>～</SText>
        <SDateField name="nyukayoteiYmdTo" {...register(4)} />

        <SLabel gridColumn="1">営業所</SLabel>
        {isEigyoCdHonsha ? (
          <STextField
            code
            label="営業所コード（開始）"
            name="eigyoCdFrom"
            {...register(5)}
            size={6}
            dialog={<B000120 />}
            handleSubmit={(data: any) => {
              methods.setValue("eigyoCdFrom", data.eigyoCd);
            }}
            gridColumn="span 2"
          />
        ) : (
          <STextField
            label="営業所コード（開始）"
            name="eigyoCdFrom"
            disabled
            gridColumn="span 2"
          />
        )}
        <SText>～</SText>
        {isEigyoCdHonsha ? (
          <STextField
            code
            label="営業所コード（終了）"
            name="eigyoCdTo"
            {...register(6)}
            size={6}
            dialog={<B000120 />}
            handleSubmit={(data: any) => {
              methods.setValue("eigyoCdTo", data.eigyoCd);
            }}
            gridColumn="span 2"
          />
        ) : (
          <STextField
            label="営業所コード（終了）"
            name="eigyoCdTo"
            disabled
            gridColumn="span 2"
          />
        )}

        <SLabel gridColumn="1">発注担当部門</SLabel>
        <SNumberField
          name="bumonCdFrom"
          code
          size={6}
          gridColumn="span 2"
          dialog={<B000130 />}
          handleSubmit={(data: any) => {
            methods.setValue("bumonCdFrom", data.bumonCd);
          }}
          {...register(7)}
        />
        <SText>～</SText>
        <SNumberField
          name="bumonCdTo"
          code
          size={6}
          gridColumn="span 2"
          dialog={<B000130 />}
          handleSubmit={(data: any) => {
            methods.setValue("bumonCdTo", data.bumonCd);
          }}
          {...register(8)}
        />
        <SLabel gridColumn="9">発注担当者</SLabel>
        <SNumberField
          name="shainCdFrom"
          code
          size={7}
          dialog={<B000140 />}
          handleSubmit={(data: any) => {
            methods.setValue("shainCdFrom", data.shainCd);
          }}
          {...register(9)}
        />
        <SText>～</SText>
        <SNumberField
          name="shainCdTo"
          code
          size={7}
          dialog={<B000140 />}
          handleSubmit={(data: any) => {
            methods.setValue("shainCdTo", data.shainCd);
          }}
          {...register(10)}
        />

        <SLabel gridColumn="1">発注No.</SLabel>
        <SNumberField
          name="hachudenpyoNoFrom"
          code
          size={10}
          {...register(11)}
          gridColumn="span 2"
        />
        <SText>～</SText>
        <SNumberField
          name="hachudenpyoNoTo"
          code
          size={10}
          gridColumn="span 2"
          {...register(12)}
        />

        <SLabel gridColumn="1">仕入先</SLabel>
        <SNumberField
          name="shireCd"
          code
          size={6}
          gridColumn="span 2"
          onBlur={() => B000170ShireNmr(methods, navigate, setMsg)}
          dialog={<B000170 />}
          handleSubmit={(data: any) => {
            methods.setValue("shireCd", data.shireCd);
            methods.setValue("shireNmr", data.shireNmr);
          }}
          {...register(13)}
        />
        <STextField name="shireNmr" size={24} disabled gridColumn="span 4" />
        <SLabel gridColumn="9">倉庫</SLabel>
        <SNumberField
          name="sokoCd"
          code
          size={3}
          {...register(14)}
          onBlur={() => B000190SokoNmr(methods, navigate, setMsg)}
          dialog={<B000190 />}
          handleSubmit={(data: any) => {
            methods.setValue("sokoCd", data?.sokoCd);
            methods.setValue("sokoNmr", data?.sokoNmr);
          }}
        />
        <STextField name="sokoNmr" size={20} disabled gridColumn="span 3" />

        <SLabel gridColumn="1">商品分類</SLabel>
        <SNumberField
          label="商品分類(大)"
          name="shodaibun"
          code
          size={3}
          {...register(15)}
        />
        <SNumberField
          label="商品分類(中)"
          name="shochubun"
          code
          size={3}
          {...register(16)}
        />
        <SNumberField
          label="商品分類(小)"
          name="shoshobun"
          code
          size={3}
          gridColumn="span 2"
          dialog={<B000202 />}
          handleSubmit={(data: any) => {
            if (data.shochubun === null) {
              methods.setValue("shodaibun", data.shodaibun);
              methods.setValue("shochubun", "");
              methods.setValue("shoshobun", "");
            } else if (data.shoshobun === null) {
              methods.setValue("shodaibun", data.shodaibun);
              methods.setValue("shochubun", data.shochubun);
              methods.setValue("shoshobun", "");
            } else {
              methods.setValue("shodaibun", data.shodaibun);
              methods.setValue("shochubun", data.shochubun);
              methods.setValue("shoshobun", data.shoshobun);
            }
          }}
          {...register(17)}
        />
        <SLabel gridColumn="9">商品</SLabel>
        <SNumberField
          label="商品コード"
          name="shohinCd"
          code
          size={10}
          onBlur={() => B000200ShohinNmr(methods, navigate, setMsg)}
          dialog={<B000200 />}
          handleSubmit={(data: any) => {
            methods.setValue("shohinCd", data.shohinCd);
            methods.setValue("shohinNmr", data.shohinNmr);
          }}
          {...register(18)}
        />
        <STextField name="shohinNmr" size={24} disabled gridColumn="span 3" />

        <SLabel gridColumn={1}>完了</SLabel>
        <SCodeSelect
          name="kanryoKbn"
          options={HachuKanryoKbn}
          {...register(19)}
          gridColumn="span 2"
        />

        <SLabel gridColumn="9">JANコード</SLabel>
        <SNumberField
          label="JANコード"
          name="janCd"
          code
          size={13}
          onBlur={() => B000200JanshohinNm1(methods, navigate, setMsg)}
          dialog={<B000200 />}
          handleSubmit={(data: any) => {
            methods.setValue("janCd", data.janCd);
            methods.setValue("janshohinNm", data.shohinNmr);
          }}
          gridColumn="span 2"
          {...register(20)}
        />
        <STextField name="janshohinNm" size={24} disabled gridColumn="span 2" />
        <SLabel gridColumn="1">出力順</SLabel>
        <SCodeSelect
          label="出力順"
          name="shuturyokuKbn"
          options={B040030SyuturyokuKbn}
          gridColumn="span 2"
          {...register(21)}
        />
        <SLabel gridColumn="9">商品種別</SLabel>
        <SCodeSelect
          name="shohinsyubetsuKbn"
          options={ZenkenShohinshubetsuKbn}
          {...register(22)}
          gridColumn="span 2"
        />
        <SNormalButton
          label={labels.buttons.search}
          gridRow="9"
          gridColumn="13"
          align="right"
          onClick={handleClickSearchButton}
          {...register(23)}
        />
      </SFrame>
      <SFrame>
        <STable
          keyName="gyoNo"
          data={handleSearch}
          columns={columns}
          tableRef={tableRef}
          width={1260}
          height={440}
          fixed={5}
          onRowClick={handleSelectTableRow}
          handleDoubleClick={handleDoubleClickTableRow}
          pageSize={pageSize}
          onPageChange={handleResetSearch}
        />
      </SFrame>
      <SFrame gridTemplateColumns="68.7rem 4rem 0.5rem 5rem">
        <SNormalButton
          label={labels.buttons.detail}
          disabled={disabledHachuDetail}
          onClick={handleClickShowDetailButton}
          align="right"
          gridColumn={2}
          {...register(24)}
        />
        <SFileButton
          label={labels.buttons.excel}
          onClick={handleClickExcelButton}
          disabled={disabledHachuExcel}
          gridColumn={4}
          {...register(25)}
        />
      </SFrame>
    </FormProvider>
  );
};
